module.exports = __webpack_public_path__ + "03503d892642a931359c8a5875a23970.svg";